import request from './request'

export interface Class {
  id: number
  name: string
  description: string
  teacher_id: number
  teacher_name: string
  student_count: number
  created_at: string
  is_new?: boolean
}

export interface ClassStudent {
  id: number
  user_id: number
  username: string
  avatar: string
  joined_at: string
  is_online?: boolean
  is_teacher?: boolean
}

export interface Homework {
  id: number
  class_id: number
  title: string
  description: string
  problem_ids: number[]
  problems: {
    id: number
    title: string
    difficulty: string
  }[]
  start_time: string
  end_time: string
  status: 'upcoming' | 'ongoing' | 'ended'
  created_at: string
}

export interface HomeworkSubmission {
  problem_id: number
  problem_title: string
  status: string
  score: number
  submit_count: number
  last_submit_time: string
}

export interface MyClassResponse {
  list: Class[]
}

export interface ClassDetailResponse {
  class: Class
  students: ClassStudent[]
  is_teacher: boolean
  is_student: boolean
}

export interface HomeworkListResponse {
  homeworks: Homework[]
  total: number
  page: number
  page_size: number
}

export interface HomeworkDetailResponse {
  homework: Homework
  submissions: HomeworkSubmission[]
}

// 获取我的班级列表
export function getMyClasses() {
  return request.get<MyClassResponse>('/classes/my')
}

// 获取班级详情
export function getClassDetail(id: number) {
  return request.get<ClassDetailResponse>(`/classes/${id}`)
}

// 获取班级作业列表
export function getClassHomework(classId: number, params: { page?: number; page_size?: number }) {
  return request.get<HomeworkListResponse>(`/classes/${classId}/homework`, { params })
}

// 获取作业详情
export function getHomeworkDetail(classId: number, homeworkId: number) {
  return request.get<HomeworkDetailResponse>(`/classes/${classId}/homework/${homeworkId}`)
}

// 加入班级
export function joinClass(data: { code: string }) {
  return request.post('/classes/join', data)
}
